import { render, staticRenderFns } from "./ShipCitizenScienceDashboardWidget.vue?vue&type=template&id=783ed100&scoped=true"
import script from "./ShipCitizenScienceDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipCitizenScienceDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipCitizenScienceDashboardWidget.vue?vue&type=style&index=0&id=783ed100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ed100",
  null
  
)

export default component.exports